export default __webpack_public_path__ + "static/media/cube-icon-active.fb49aa8b.svg";